import { AdminListUserComplaintFilter } from '../../graphql/API';
import { adminGetUnreadUserComplaintCount } from '../../graphql/queries';
import { executeGql, processGqlResult } from '../../utils/gql-utils';

export const adminGetUnreadUserComplaintCountApi = async (
  filter: AdminListUserComplaintFilter,
): Promise<number> => {
  const result = await executeGql<number>(adminGetUnreadUserComplaintCount, { filter });
  return processGqlResult<number>('adminGetUnreadUserComplaintCount', result);
};
